import { Phone, EnvelopeSimple, MapPin, Globe, InstagramLogo } from "@phosphor-icons/react";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-20" data-testid="contact-page">
      <p className="text-xs tracking-[0.3em] uppercase text-[#FF6B1A] mb-4">On parle ?</p>
      <h1 className="font-display text-5xl sm:text-7xl leading-none mb-4">CONTACT</h1>
      <p className="text-white/60 text-lg max-w-2xl mb-12">
        Un sponsor ? Une question ? Envie de faire partie de l'aventure ? Action Impact Jeunesse répond vite et bien.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card icon={<Phone size={28} weight="bold" />} label="Téléphone" value="06 95 62 29 53" href="tel:+33695622953" testid="contact-phone" />
        <Card icon={<EnvelopeSimple size={28} weight="bold" />} label="Email" value="actionimpactjeunesse@gmail.com" href="mailto:actionimpactjeunesse@gmail.com" testid="contact-email" />
        <Card icon={<Globe size={28} weight="bold" />} label="Site web" value="actionimpactjeunesse.com" href="https://www.actionimpactjeunesse.com" testid="contact-website" />
        <Card icon={<InstagramLogo size={28} weight="bold" />} label="Instagram" value="@action.impact.jeunesse" href="https://www.instagram.com/action.impact.jeunesse/" testid="contact-instagram" />
        <Card icon={<MapPin size={28} weight="bold" />} label="Lieu du tournoi" value="Quartier Jean-Yole, La Roche-sur-Yon" testid="contact-location" />
      </div>

      <section className="mt-16 uf-card p-8">
        <div className="flex items-start gap-6 flex-wrap">
          <img
            src="https://customer-assets.emergentagent.com/job_festurban-live/artifacts/l19s6upi_logo%20action%20impact%20jeunesse.png"
            alt="Action Impact Jeunesse"
            className="w-28 h-28 rounded-full border border-white/10 object-cover shrink-0"
            data-testid="aij-logo"
          />
          <div className="flex-1 min-w-[240px]">
            <h2 className="font-display text-3xl mb-4">À PROPOS D'ACTION IMPACT JEUNESSE</h2>
            <p className="text-white/70 leading-relaxed">
              Association engagée auprès de la jeunesse de La Roche-sur-Yon, Action Impact Jeunesse œuvre pour l'insertion,
              la cohésion sociale et la valorisation des talents de la ville à travers des événements sportifs, culturels et citoyens.
            </p>
            <p className="text-[#FF6B1A] font-display text-xl tracking-wider mt-4">
              AGIR · INSPIRER · IMPACTER · CONSTRUIRE L'AVENIR
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

function Card({ icon, label, value, href, testid }) {
  const inner = (
    <div className="uf-card p-6 h-full flex items-start gap-4 hover:border-[#FF6B1A] transition-colors" data-testid={testid}>
      <div className="text-[#FF6B1A] mt-1">{icon}</div>
      <div>
        <p className="text-xs tracking-[0.2em] uppercase text-white/50">{label}</p>
        <p className="text-lg font-bold mt-1 break-all">{value}</p>
      </div>
    </div>
  );
  return href ? (
    <a href={href} target="_blank" rel="noreferrer" className="block">{inner}</a>
  ) : (
    inner
  );
}
